import { injectable } from 'inversify';
import container from '@/container';
import {
    CONTRACTS,
    StringsServiceContract,
    FetchServiceContract
} from '@/core/contracts';
import { Localization } from '@/localization';

interface LocalStrings {
    [id: string]: string;
}

@injectable()
export class StringsService implements StringsServiceContract {
    private strings: LocalStrings = {};
    private localization!: Localization;

    public async setupLocalization(localization: Localization) {
        this.localization = localization;
    }

    public async startupAsync(): Promise<any> {
        await this.reloadAsync();
    }

    public async reloadAsync(): Promise<void> {
        const fetchService = await container.get<FetchServiceContract>(
            CONTRACTS.FetchService
        );
        const strings = await fetchService.get<LocalStrings>('/strings');
        const locale = await fetchService.get<object>('/locale');

        if (Array.isArray(strings)) {
            this.strings = strings.reduce((acc: LocalStrings, pair: any) => {
                acc[pair.key] = pair.value;
                return acc;
            }, {});
        } else {
            this.strings = strings;
        }

        this.localization.setLocale(locale);
    }

    public get(key: string): string {
        const lowerKey = key.toLowerCase();
        const translationKey = Object.keys(this.strings).find(
            stringKey => stringKey.toLowerCase() === lowerKey
        );

        return translationKey ? this.strings[translationKey] : `KEY_${key}`;
    }
}
